import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
const ConsultationSearchBar = ({
    keyword = "",
    onSearch,
    onAdd
}) => {
    const { t } = useTranslation();
    const [value, setValue] = useState(keyword);

    //-----------------------------------------------------
    // Synchronisation avec le parent
    //-----------------------------------------------------
    useEffect(() => {
        setValue(keyword);
    }, [keyword]);

    //-----------------------------------------------------

    const handleSubmit = (e) => {
        e.preventDefault();
        if (onSearch) {
            onSearch(value);
        }
    };
    //-----------------------------------------------------
    const handleReset = () => {
        setValue("");
        if (onSearch) {
            onSearch("");
        }
    };

    //-----------------------------------------------------

    return (
        <form
            className="card shadow-sm mb-4"
            onSubmit={handleSubmit}
        >
            <div className="card-body">
                <div className="row g-3 align-items-center">
                    <div className="col-md-7">
                        <div className="input-group">
                            <span className="input-group-text">
                                <i className="bi bi-search"></i>
                            </span>
                            <input
                                type="text"
                                className="form-control"
                                placeholder={t("consultationRequest.searchPlaceholder")}
                                value={value}
                                onChange={(e) => setValue(e.target.value)}
                            />
                        </div>
                    </div>
                    <div className="col-md-5">
                        <div className="d-flex justify-content-end gap-2">
                            <button
                                type="submit"
                                className="btn btn-success"
                            >
                                <i className="bi bi-search me-2"></i>
                                {t("button.search")}
                            </button>

                            <button
                                type="button"
                                className="btn btn-outline-secondary"
                                onClick={handleReset}
                            >
                                <i className="bi bi-arrow-clockwise me-2"></i>
                               {t("button.reset")}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    );
};

export default ConsultationSearchBar;